
























import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '../../lib/abpbase'
import countup from 'vue-countupjs'

@Component({
    components:{countup}
})
export default class extends AbpBase{
    @Prop({type:String,default:''}) title:string;
    @Prop({type:String,default:''}) bTitle:string;
    //值
    @Prop({type:String,default:''}) value:string;
    @Prop({type:String,default:''}) bValue:string;
    //统计icon
    @Prop({type:String,default:''}) icon:string;
    @Prop({type:String,default:''}) iconText:string;
    @Prop({type:String,default:''}) bIcon:string;
    //加载
    @Prop({type:Boolean,default:false}) loading:Boolean;
}
